export default "__VITE_ASSET__0da902a1__"